import {
  CommonUtils,
  HighlightDate,
  HighlightLegend,
  IEntity,
  StandardEntity,
} from '@infodata-group/inf-commons';
import { Absence } from './absence';
import { AbsenceType } from './absence-type';
import { HolidayTask } from './holiday-task';

export class Holiday implements IEntity {
  dates: Date[] = [];
  lock: boolean;
  public static absenceType = new AbsenceType(
    'F',
    'Férié',
    null,
    '#C8C8C8',
    '#C8C8C8',
  );
  public static state = new StandardEntity('F', 'Férié');

  constructor(dates: string[]) {
    for (const date of dates) {
      this.dates.push(CommonUtils.convertStrToDate(date));
    }
  }

  serialize() {
    throw new Error('Not implemented');
  }

  getId(): string {
    return '';
  }

  getLabel(): string {
    return '';
  }

  generateTasks(): Absence[] {
    const tasks: Absence[] = [];
    for (const holiday of this.dates) {
      tasks.push(this.createTask(holiday));
    }
    return tasks;
  }

  private createTask(date: Date): Absence {
    return new HolidayTask(date);
  }

  generateHighlights(legend: HighlightLegend): HighlightDate[] {
    const highlights = [];
    this.dates
      .filter((d) => d != null)
      .forEach((d) => {
        highlights.push(new HighlightDate(d, legend));
      });
    return highlights;
  }

  getHoliday(date: Date): Absence {
    if (this.dates.find((d) => CommonUtils.compareDate(date, d))) {
      return this.createTask(date);
    } else {
      return null;
    }
  }

  getDates(year: number): Date[] {
    return this.dates.filter((d) => d.getFullYear() === year);
  }
}
